import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-50 overflow-x-hidden vue-modal-background"
};
const _hoisted_2 = {
  class: "bg-gray-50 w-4/12 shadow-lg rounded-sm absolute top-44 right-1/4 px-10 py-8"
};
const _hoisted_3 = {
  class: "flex justify-between"
};
const _hoisted_4 = {
  class: "flex w-full py-2"
};
const _hoisted_5 = {
  class: "w-7/12"
};
const _hoisted_6 = {
  class: "flex w-full py-2"
};
const _hoisted_7 = {
  class: "w-5/12"
};
const _hoisted_8 = {
  class: "w-7/12"
};
const _hoisted_9 = {
  class: "py-2 pt-8 flex justify-end"
};
import { reactive } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import axios from "axios";
import LlTooltip from "@/components/LlTooltip.vue";
export default {
  __name: 'FirmCreate',
  props: {
    listsState: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    }
  },
  emits: ["cancel", "update"],
  setup(__props, {
    emit: __emit
  }) {
    const createState = reactive({
      company: {
        seats: 1,
        name: ""
      },
      saving: false
    });
    const props = __props;
    const emit = __emit;
    async function create() {
      if (!createState.company.seats || !createState.company.name) {
        props.alerts.error("Name and Seats are required");
        return;
      }
      createState.saving = true;
      try {
        await axios({
          url: "/companies",
          data: createState.company,
          method: "POST"
        });
        props.alerts.success("The account was successfully setup.");
        emit("update");
      } catch (error) {
        props.alerts.error(error.response.data.message);
      } finally {
        createState.saving = false;
      }
    }
    const cancel = () => {
      emit("cancel");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "text-left font-extrabold text-2xl"
      }, "Set up Firm", -1)), (_openBlock(), _createElementBlock("svg", {
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => cancel(), ["prevent"])),
        width: "20",
        height: "20",
        class: "cursor-pointer ml-4 mb-4",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, [...(_cache[5] || (_cache[5] = [_createElementVNode("g", {
        transform: "translate(2.000000, 2.000000)",
        stroke: "#242020"
      }, [_createElementVNode("path", {
        d: "M0.24,0.24 L11.76,11.76",
        "stroke-width": "2"
      }), _createElementVNode("path", {
        d: "M0.24,0.24 L11.76,11.76",
        "stroke-width": "2",
        transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
      })], -1)]))]))]), _cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "py-4 text-base text-left text-gray-900"
      }, " This will set up a new LeanLaw account for one of your clients. The account will be started with a two week trial. ", -1)), _createElementVNode("div", _hoisted_4, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "w-5/12"
      }, [_createElementVNode("label", null, "Firm Name")], -1)), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
        class: "w-full",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => createState.company.name = $event),
        name: "name",
        "focus-me": "true",
        placeholder: "Name of the firm"
      }, null, 512), [[_vModelText, createState.company.name]])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("label", null, [_cache[9] || (_cache[9] = _createTextVNode("Expected Seats ", -1)), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("The expected number of seats for the firm-- the number of users needed, not including yourself.", -1)]))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
        type: "number",
        class: "w-full",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => createState.company.seats = $event),
        name: "seats",
        placeholder: "Expected number of seats"
      }, null, 512), [[_vModelText, createState.company.seats]])])]), _createElementVNode("div", _hoisted_9, [_createVNode(LlSecondaryButton, {
        class: "px-12 mr-4",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => cancel(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        color: "primary",
        class: "px-12",
        id: "save-matter-button",
        disabled: createState.saving,
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => create(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Set up Firm ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])])]);
    };
  }
};